export enum ParameterType {
  NUMBER = 'int',
  FLOAT = 'float',
  START_INDEX = 'start_index',
  END_INDEX = 'end_index',
  INTERVAL_LIST = 'intervals',
  INDEX_LIST = 'int_list',
  BOOL = 'booleanint',
  TEXT = 'text',
}

export enum Task {
  PCR = 'pcr',
  QPCR_DYES = 'qpcr-dyes',
  QPCR_PROBE = 'qpcr-probe',
  SEQUENCING = 'sequencing',
}
